<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div *ngIf="mode != 'author'" class="avatar">
          <ngx-view-user-display
            [user]="lecture.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <h6
            *ngIf="lecture.title"
            (click)="onClick()"
            class="link text-heading"
          >
            {{ lecture.title }}
          </h6>
          <p *ngIf="lecture.description" class="link" (click)="onClick()">
            {{
              lecture.description.length < 100
                ? lecture.description
                : lecture.description.substring(0, 100) + "..."
            }}
          </p>
        </div>
      </div>
    </div>
  </nb-card-header>

  <nb-card-footer>
    <nb-actions class="button-actions">
      <nb-action>
        <nb-icon class="action-icon" icon="like" pack="liked-icon"></nb-icon>
        <span>{{ lecture.noLiked ? lecture.noLiked : "." }}</span>
      </nb-action>

      <nb-action>
        <nb-icon icon="message-square-outline"></nb-icon>
        <span>{{ lecture.noComment ? lecture.noComment : "." }}</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
